export const DokumentPogodbaEnum = {
  PANDA_POSLOVNA_LICENCNA_POGODBA: 390
}



// WEBPACK FOOTER //
// ./src/assets/js/Enum/Narocilnica/DokumentPogodbaEnum.js